angular.module('routes.PayloadResolver', ['stack'])

/**
 * The PayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class PayloadResolver
 * @constructor
 * @module routes.PayloadResolver
 */
.factory('PayloadResolver', [
  '$q',
  '$rootScope',
  '$http',
  '$location',
  '$window',
  'GLOBAL',
  'ModelsService',
  'LoginService',
  function ($q, $rootScope, $http, $location, $window, GLOBAL, ModelsService, LoginService) {
    'use strict';

    return function () {
      var queue;
      var ls;

      var urlParam = new URLSearchParams(window.location.search);
      const accessToken = urlParam.get('access_token');
      const isMathXLLaunch = urlParam.get('isMathXLLaunch');

      if ($window.localStorage.newman) {
        ls = JSON.parse($window.localStorage.newman);
        LoginService.setToken(ls.token);
        LoginService.isAuthoring = ls.authoring;
      } else if (accessToken !== null && accessToken !== undefined) {
        window.localStorage.isMathXLLaunch = isMathXLLaunch;
        $window.localStorage.newmanhash = JSON.stringify({ token: accessToken });
        LoginService.setToken(accessToken);
      } else if ($window.localStorage.newmanhash) {
        ls = JSON.parse($window.localStorage.newmanhash);
        LoginService.setToken(ls.token);
      }

      if (!ModelsService.read('endpoints')) {
        queue = [
          ModelsService.initialize('endpoints', GLOBAL.apiPath + '/endpoints'),
          ModelsService.initialize('schemas', GLOBAL.schemasPath + 'schemas.json')
        ];

        return $q.all(queue)
          .then(function () {
            // initialize events model
            ModelsService.write('events', []);
            // initialize report
            ModelsService.write('reports', []);

            // load configuration file
            return $http.get($rootScope.rootpath + '/apps/config.json');
          })
          .then(function (configResponse) {
            $rootScope.config = configResponse.data;

            var headerSuccessUrl = window.location.href;
            var PISeesionInitExpTime = new Date();
            var urlParams = new URLSearchParams(window.location.search);

            function headerInitiatePiSession() {
              console.log($rootScope.config.PiSessionAuthEnabled);

              const currentTime = new Date();
              if ($rootScope.config.PiSessionAuthEnabled) {
                PISeesionInitExpTime = new Date(new Date().getTime() + $rootScope.config.PISessionIdleTimeoutSeconds * 1000);
                if (headerSuccessUrl.split('?').length > 0)
                  headerSuccessUrl = headerSuccessUrl.split('?')[0];
                console.log("inside initiatePiSession");
                headerDoPiInit();
              } else if ($rootScope.config.PiSessionAuthEnabled && $rootScope.config.SMStoPIBridge && urlParams.has('iesError')) {
                headerSMStoPIBridgeRedirects();
              }
            }

            function headerHandleSessionKnownEvent(evntData, piSession) {
              const sessionState = piSession.hasValidSession($rootScope.config.PIGracePeriodSeconds);
              console.log('piSession session state: ' + sessionState);
              if (sessionState === piSession.Success) {
                console.log('piSession Success for user: ' + piSession.userId());
                localStorage.setItem('piSession', piSession.userId());
                console.log('After SessionStateKnownEvent');
                initiateOneTrust();
              } else if ($rootScope.config.PiSessionAuthEnabled && urlParams.has('iesError')) {
                window.location.href = window.location.origin + '/error';
              }
            }

            function headerDoPiInit() {
              console.log("inside doPiInit");
              const options = {
                'loginSuccessUrl': encodeURI(headerSuccessUrl),
                'checkSessionMilliseconds': $rootScope.config.PICheckSessionMilliseconds,
                'sessionIdleTimeoutSeconds': $rootScope.config.PISessionIdleTimeoutSeconds,
                'sessionIdleTimeoutWarningSeconds': $rootScope.config.PISessionIdleTimeoutWarningSeconds,
                'useDefaultIdleTimoutWarningPopup': $rootScope.config.PIUseDefaultIdleTimoutWarningPopup,
                'defaultTimeoutSeconds': $rootScope.config.PIdefaultTimeoutSeconds,
                'requireLogin': $rootScope.config.PIRequireLogin,
                'autoRefresh': $rootScope.config.PIAutoRefresh,
                'monitorUserActivity': $rootScope.config.PIMonitorUserActivity,
                'avoidReInit': $rootScope.config.PIAvoidReInit
              };
              console.log("Step 1 : PiSession -initialization ");
              piSession.initialize($rootScope.config.PISessionAuthClientID, options);
              console.log('piSession : Initialized Successfully!!', piSession.SessionStateKnownEvent);
              piSession.on(piSession.SessionStateKnownEvent, function (evntData) {
                console.log('Before SessionStateKnownEvent');
                headerHandleSessionKnownEvent(evntData, piSession);
              });
              piSession.on(piSession.LogoutEvent, function () {
                window.location.href = $rootScope.config.MathXLLoginPageUrl;
              });
              piSession.on(piSession.SessionTimedOutEvent, function () {
                window.location.href = $rootScope.config.MathXLLoginPageUrl;
              });
			  
			  // Ensure session state is checked even if SessionStateKnownEvent is not emitted immediately
          setTimeout(function () {
            const sessionState = piSession.hasValidSession($rootScope.config.PIGracePeriodSeconds);
            console.log('Manual session check: ' + sessionState);

            if (sessionState === piSession.Success) {
              headerHandleSessionKnownEvent(null, piSession);
            } else {
              console.warn('Session not valid during manual check, waiting for event or redirecting...');
              // Optional: force redirect or show login
              // if (!$rootScope.config.PIAvoidReInit && !piSession.hasValidSession()) {
              //   piSession.requireAuthentication(); // if API exists
              // }
            }
          }, 3000); // 1-second delay to give piSession time to initialize
		  
            }

            function headerSMStoPIBridgeRedirects() {
              const urlBuilder = [];
              const success_url = window.location.href + "?SMSPIBridge=true";
              urlBuilder.push(environment.PISMSBridgeBaseUrl);
              urlBuilder.push("success_url=" + success_url);
              urlBuilder.push("&loginurl=" + $rootScope.config.MathXLLoginPageUrl);
              urlBuilder.push("&errurl=" + $rootScope.config.MathXLLoginPageUrl);
              urlBuilder.push("&siteid=" + $rootScope.config.siteID);
              urlBuilder.push("&client_id=" + $rootScope.config.PISessionAuthClientID);
              urlBuilder.push("&smsAware=true");
              PISeesionInitExpTime = new Date(new Date().getTime() + $rootScope.config.PISessionIdleTimeoutSeconds * 1000);
              console.log("Step 2 : PiSession - SMSPIBridge URL sent to SMS: " + urlBuilder.join(''));
              window.location.href = urlBuilder.join('');
            }

            function headerRemoveParamFromURL(url, param) {
              while (url.includes(param)) {
                const urlObj = new URL(url);
                urlObj.searchParams.delete(param);
                url = urlObj.toString();
              }
              return url;
            }

            function initiateOneTrust() {
              const script1 = document.createElement('script');
              script1.src = 'https://cdn.cookielaw.org/consent/49ebfd86-5580-4c64-80ee-88022acba249-test/OtAutoBlock.js';
              script1.type = 'text/javascript';
              document.head.appendChild(script1);

              const script2 = document.createElement('script');
              script2.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
              script2.type = 'text/javascript';
              script2.setAttribute("charset", "UTF-8");
              script2.setAttribute("data-domain-script", "49ebfd86-5580-4c64-80ee-88022acba249-test");
              document.head.appendChild(script2);

              const script3 = document.createElement('script');
              script3.type = "text/javascript";
              script3.textContent = "function OptanonWrapper() {  }";
              document.head.appendChild(script3);
            }

            if (window.localStorage.isMathXLLaunch == 'true')
              headerInitiatePiSession();

            if ($window.localStorage.newman) {
              queue = [];
              return ModelsService.get(
                'users',
                GLOBAL.apiPath + '/users',
                { id: JSON.parse($window.localStorage.newman).user }
              );
            }

            return {};
          });
      }

      return {};
    };
  }
]);
